import { Component, OnInit, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IFormField } from "../../interfaces/iform-field";
import { FormFieldConfig } from "../../models/form-field-config";
import { FormUtils } from "../../form-utils";
import { FieldError } from "../../models/field-error";

@Component({
    selector: "wtf-form-input",
    templateUrl: "./form-input.component.html",
    styleUrls: ["./form-input.component.scss"],
})
export class FormInputComponent implements OnInit, IFormField {
    propertyName: string;
    group: FormGroup;
    config: FormFieldConfig;
    errors = new Array<FieldError>();
    isVisible = true;
    isDisabled = true;
    inline = false;

    constructor() {}

    ngOnInit() {
        if (this.config) {
            this.propertyName = this.config.fieldInfo.name;
            this.inline = this.config.fieldInfo.inline;
        }
    }

    setObservableDataSource(data: any) {}

    getErrorList() {
        const control = this.group.controls[this.config.fieldInfo.name];
        this.errors.length = 0;

        if (control.errors) {
            this.errors = FormUtils.getErrorRepresentation(control.errors);
        }

        return this.errors;
    }

    onFocus(event) {
        if (this.errors) {
            this.errors.length = 0;
        }
    }

    onLostFocus(event) {
        this.getErrorList();
    }

    setVisible(isVisible: boolean) {
        this.isVisible = isVisible;
    }

    isControlVisible(): boolean {
        return this.isVisible;
    }
}
